import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import { createVfm } from 'vue-final-modal'
import {createRouter, createWebHistory} from 'vue-router'
import App from './App.vue'
import Maska from 'maska'
import 'vue-final-modal/style.css'
import en from './locale/en.json';
import ru from './locale/ru.json';

// import VueCookies from 'vue-cookies';
// import Toast from "vue-toastification";

// import App from './App.vue';
import UserSpace from './components/UserSpace';
import OperatorSpace from './components/OperatorSpace';
import SuccessAuth from './components/SuccessAuth';
import FailAuth from './components/FailAuth';
import LoginPage from  './components/Login';
import HomePlace from './components/HomePlace'
import socketioservice from './services/socketioservice';
import {validateToken} from "./services/api";
// import Localize from "./services/const";

// import ModalProvider from "vue-modal-provider";

// Vue.config.productionTip = false
// Vue.use(VueRouter);
// Vue.use(router)
const messages = {
  en,
  ru
};

const i18n = createI18n({
  locale: 'en', // set locale
  fallbackLocale: 'en', // set fallback locale
  messages, // our translations
});

const routes = [
  { path: '/', component: UserSpace, meta:{needauth: false }},
  { path: '/operator', component: OperatorSpace, meta:{needauth: true}},
  //{ path: '/operator', component: OperatorSpace, meta:{needauth: false}},
  { path: '/auth-success', component: SuccessAuth, meta:{needauth: false}},
  { path: '/auth-fail', component: FailAuth, meta:{needauth: false}},
  { path: '/login', component: LoginPage, meta:{needauth:false}},
  { path: '/home', component: HomePlace, meta: {needauth: false}}
];

socketioservice.setupSocketConnection()

const router = createRouter({
  history: createWebHistory(),
  routes: routes
})
router.beforeEach((to, from, next) => {
  console.log(to);
  console.log(from);
  if(to.meta.needauth){
    validateToken().then(res => {
      if(res.data.uid){
        next();
      }else{
        next("/login")
      }
    }).catch((err) => {
      console.log(err);
      next("/login")
    })
  }else{
    next()
  }
    
  
})
const vfm = createVfm()

createApp(App).use(router).use(vfm).use(Maska).use(i18n).mount('#app')

